/**
 * リプライ投稿に付与されるバッジ種別に関するUtil。
 */
export default class BadgeTypeUtil {
	/**
	 * リプライ>バッジの種類。
	 */
	private static readonly badgeType = {
		/**
		 * 認定ファン。
		 */
		officialFan: "officialFan",
		/**
		 * スタッフ。
		 */
		staff: "staff",
	};

	/**
	 * 指定されたバッジが「認定ファン」であるかどうかチェックする。
	 * @returns `true`:認定ファン / `false`:認定ファンではない
	 */
	public static isOfficialFan(badgeType: string | null): boolean {
		if (!badgeType) {
			return false;
		}
		if (badgeType === this.badgeType.officialFan) {
			return true;
		}

		return false;
	}

	/**
	 * 指定されたバッジが「スタッフ」であるかどうかチェックする。
	 * @returns `true`:スタッフ / `false`:スタッフではない
	 */
	public static isStaff(badgeType: string | null): boolean {
		if (!badgeType) {
			return false;
		}
		if (badgeType === this.badgeType.staff) {
			return true;
		}

		return false;
	}
}
